import type { GTMEcommerce, LeadFormTrackingContext } from '@telialt/gtm-tracking/src/types';

export interface LeadSuccessProps {
    responseTimeText?: string;
    successExitLink?: string;
    successExitLinkText?: string;
}
export interface LeadSmsConfirmProps {
    smsConfirmDescription?: string;
}
export interface LeadInfoProps {
    title?: string;
    description?: string;
    helpText?: string;
    helpTooltip?: string;
    hideHelpTooltip?: boolean;
    complementaryComment?: string;
    showComplementaryComment?: boolean;
    prefilledComment?: string;
}
export type LeadGAEventEcommerce = GTMEcommerce;

export interface LeadFormProps extends LeadInfoProps, LeadSuccessProps, LeadSmsConfirmProps {
    leadText?: string;
    leadsType?: LeadsApplicationFormType;
    serviceType?: string;
    possibilityComment?: string;
    addressText?: string;
    addressId?: string;
    gaEventEcommerce?: LeadGAEventEcommerce;
    gaTracking?: LeadFormTrackingContext;
    onSubmit?: (leadId?: string) => void;
}
export interface LeadModalProps extends LeadFormProps {
    bannerImage?: string;
    isOpen?: boolean;
    onClose?: () => void;
    dataTest?: string;
}

type LeadRequestCommonData = {
    p_text_data: string;
    p_legal_text: string;
    p_segment: string;
    p_source_url: string;
    p_tracker_client_id: string;
};

export enum LeadsApplicationFormType {
    PlanChange = 'PLAN_CHANGE',
    LeadsForm = 'LEADS_FORM',
}

export type LeadSubmitRequestData = LeadRequestCommonData & {
    p_address_text: string;
    p_b2b_code: string;
    p_comment?: string;
    p_common_name: string;
    p_email: string;
    p_telephone_number: string;
    p_service_type: string;
    leads_type?: LeadsApplicationFormType;
    possibility_comment?: string;
    p_address_id?: string;
    p_record_type?: string;
};

export type LeadSmsConfirmRequestData = LeadRequestCommonData & {
    p_confirmation_code: string;
};

export type LeadSubmitResponse = {
    data: 'ok' | 'sms' | 'error';
    message: string;
    leadId?: string;
};
